import { useLocation } from "react-router-dom";

/**
 * Returns true when the given feature flag is active — either via the
 * `?flag=true` URL param or the persisted `flag:<name>` sessionStorage key.
 */
export const useFeatureFlag = (flag: string): boolean => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return (
    params.get(flag) === "true" ||
    sessionStorage.getItem(`flag:${flag}`) === "true"
  );
};
